import { Component, OnInit } from "@angular/core";
import * as moment from "moment";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-fleetwide-ops",
	templateUrl: "./fleetwide-ops.component.html",
	styleUrls: ["./fleetwide-ops.component.scss"]
})
export class FleetwideOpsComponent implements OnInit {
	public allAssets: APIResults.Asset[];

	constructor(public api: ApiService) { }

	ngOnInit() {
		this.UpdateAssets();
	}

	public async UpdateAssets() {
		let assets = await this.api.GetAllAssets();
		assets = assets.filter(a => a.last_login && a.organization_id !== 1);
		const now = moment();
		// Attach lateness in days
		for (const asset of assets as LateAsset[]) {
			if (asset.last_login) {
				const darkDays = now.diff(moment(asset.last_login), "days");
				asset.late_days = darkDays;
			}
		}

		this.allAssets = assets;
	}

}

interface LateAsset extends APIResults.Asset {
	late_days: number;
}